import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { PageStore } from 'bernie-plugin-mobx';

import { TRIPS_FILTERED_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

import { BASEPATH } from 'constants/basepath';

/**
 * /trips/list/1
 */

export class TripsFilteredController implements Controller {
  public readonly bundles = [];
  public readonly exact = true;
  public pageId = ''; // set in trips-filtered-view
  // accepts URLs with a single digit 0-9 e.g. /trips/list/1
  public readonly path = `${BASEPATH}/trips/list/:filter(\\d+)`;
  public readonly routeName = 'trips-filtered';
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => import(/* webpackChunkName: "trips" */ 'views/trips-filtered-view')
  );
  public readonly pageName = 'page.Trip.List.Filtered';
  public readonly clickstreamPageName = 'Trip List Filtered';

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, TRIPS_FILTERED_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to trips-filtered-controller'
    });

    return Promise.resolve();
  }
}
